(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-side-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.ready === 'true') return;
    drawer.dataset.ready = 'true';

    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    const body = drawer.querySelector('[data-cart-body]');
    const itemsWrap = drawer.querySelector('[data-cart-items]');
    const emptyState = drawer.querySelector('[data-cart-empty-state]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const subtotalValue = drawer.querySelector('[data-cart-subtotal-value]');
    const notice = drawer.querySelector('[data-cart-notice]');
    let closeTimer = null;
    let noticeTimer = null;

    const strings = {
      empty: drawer.dataset.cartEmpty || 'Your cart is empty',
      emptySub: drawer.dataset.cartEmptySub || '',
      continueShopping: drawer.dataset.cartContinue || 'Continue shopping',
      subtotal: drawer.dataset.cartSubtotal || 'Total',
      checkout: drawer.dataset.cartCheckout || 'Check out',
      viewCart: drawer.dataset.cartView || 'View cart',
      remove: drawer.dataset.cartRemoveLabel || 'Remove',
      qty: drawer.dataset.cartQtyLabel || 'Qty',
      added: drawer.dataset.cartAddedMessage || 'Product added to cart',
      exists: drawer.dataset.cartExistsMessage || 'This item is already in your cart'
    };

    const setLoading = (loading) => {
      body?.classList.toggle('is-loading', loading);
      footer?.classList.toggle('is-loading', loading);
    };

    const setOpen = (open) => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      if (open) {
        drawer.hidden = false;
        window.requestAnimationFrame(() => drawer.classList.add('is-open'));
        return;
      }

      drawer.classList.remove('is-open');
      closeTimer = window.setTimeout(() => {
        drawer.hidden = true;
      }, 320);
    };

    const updateHeaderCount = (cartData) => {
      const cartButton = document.querySelector('.site-header__action--cart');
      let cartCountBadge = cartButton?.querySelector('.site-header__cart-count');
      if (!cartButton) return;

      if (cartData.item_count > 0) {
        if (!cartCountBadge) {
          cartCountBadge = document.createElement('span');
          cartCountBadge.className = 'site-header__cart-count';
          cartButton.appendChild(cartCountBadge);
        }
        cartCountBadge.textContent = String(cartData.item_count);
      } else if (cartCountBadge) {
        cartCountBadge.remove();
      }
    };

    const showNotice = (message) => {
      if (!notice || !message) return;
      if (noticeTimer) {
        window.clearTimeout(noticeTimer);
        noticeTimer = null;
      }
      notice.textContent = message;
      notice.hidden = false;
      noticeTimer = window.setTimeout(() => {
        notice.hidden = true;
      }, 2200);
    };

    const renderItems = (cart) => {
      if (!itemsWrap || !emptyState) return;

      if (!cart.items || cart.items.length === 0) {
        itemsWrap.innerHTML = '';
        itemsWrap.classList.add('is-hidden');
        emptyState.classList.remove('is-hidden');
        footer?.classList.add('is-hidden');
        return;
      }

      emptyState.classList.add('is-hidden');
      itemsWrap.classList.remove('is-hidden');
      footer?.classList.remove('is-hidden');

      itemsWrap.innerHTML = cart.items
        .map((item, index) => {
          const options = (item.options_with_values || [])
            .map((option) => `<span>${option.name}: ${option.value}</span>`)
            .join('');
          const image = item.image
            ? `<img class="cart-side-panel__item-image" src="${item.image}&width=220" alt="${item.product_title || item.title}" loading="lazy">`
            : '';
          return `
            <article class="cart-side-panel__item" role="listitem">
              <a href="${item.url}" class="cart-side-panel__item-media">${image}</a>
              <div class="cart-side-panel__item-content">
                <a href="${item.url}" class="cart-side-panel__item-title">${item.product_title || item.title}</a>
                ${options ? `<div class="cart-side-panel__item-options">${options}</div>` : ''}
                <div class="cart-side-panel__item-meta">
                  <span>${money(item.final_line_price)}</span>
                </div>
                <div class="cart-side-panel__item-actions">
                  <div class="cart-side-panel__qty" aria-label="${strings.qty}">
                    <button type="button" class="cart-side-panel__qty-button" data-cart-qty-minus data-line-key="${item.key}" ${item.quantity <= 1 ? 'disabled' : ''}>&minus;</button>
                    <span class="cart-side-panel__qty-value">${item.quantity}</span>
                    <button type="button" class="cart-side-panel__qty-button" data-cart-qty-plus data-line-key="${item.key}">+</button>
                  </div>
                  <button type="button" class="cart-side-panel__item-remove" data-cart-remove data-line-key="${item.key}">${strings.remove}</button>
                </div>
              </div>
            </article>
          `;
        })
        .join('');
    };

    const renderFooter = (cart) => {
      if (!footer || !subtotalValue) return;

      if (!cart.items || cart.items.length === 0) {
        subtotalValue.textContent = money(0);
        footer.classList.add('is-hidden');
        return;
      }

      footer.classList.remove('is-hidden');
      subtotalValue.textContent = money(cart.total_price);
    };

    const applyCartData = (cart) => {
      window.JUICED_CART_STATE = cart;
      renderItems(cart);
      renderFooter(cart);
      updateHeaderCount(cart);
    };

    const refreshDrawer = async () => {
      setLoading(true);
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await response.json();
      applyCartData(cart);
      setLoading(false);
      return cart;
    };

    document.querySelectorAll('[data-open-cart-drawer]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        setOpen(true);
        refreshDrawer().catch((error) => {
          console.error(error);
          setLoading(false);
        });
      });
    });

    document.addEventListener('cart:open', () => {
      setOpen(true);
    });

    document.addEventListener('cart:notify', (event) => {
      showNotice(event.detail?.message || '');
    });

    document.addEventListener('cart:refresh', async () => {
      try {
        await refreshDrawer();
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    });

    document.addEventListener('cart:refresh-open', async () => {
      setOpen(true);
      try {
        await refreshDrawer();
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    });

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-close]')) {
        setOpen(false);
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        const lineKey = removeButton.getAttribute('data-line-key');
        if (!lineKey) return;
        removeButton.disabled = true;
        setLoading(true);
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: { [lineKey]: 0 } })
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => {
                throw new Error(error?.description || 'Remove failed');
              });
            }
            return response.json();
          })
          .then((cart) => {
            applyCartData(cart);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            removeButton.disabled = false;
            showNotice(error.message || 'Unable to update cart');
            setLoading(false);
          });
        return;
      }

      const qtyButton = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
      if (qtyButton) {
        const lineKey = qtyButton.getAttribute('data-line-key');
        if (!lineKey) return;
        const row = qtyButton.closest('.cart-side-panel__item');
        const qtyValueNode = row?.querySelector('.cart-side-panel__qty-value');
        const currentQty = Number(qtyValueNode?.textContent || 1);
        const nextQty = qtyButton.hasAttribute('data-cart-qty-minus') ? Math.max(1, currentQty - 1) : currentQty + 1;
        qtyButton.disabled = true;
        setLoading(true);
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: { [lineKey]: nextQty } })
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => {
                throw new Error(error?.description || 'Quantity update failed');
              });
            }
            return response.json();
          })
          .then((cart) => {
            applyCartData(cart);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            qtyButton.disabled = false;
            showNotice(error.message || 'Unable to update cart');
            setLoading(false);
          });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["os2-product-media-thumbs"] && !Shopify.designMode) return;
  try {
    (() => {
    const initDesktopMediaFallbackSync = (root) => {
      const scope = root || document;
      scope.querySelectorAll('[data-product-media-thumbs-root]').forEach((gallery) => {
        if (gallery.dataset.fallbackSyncReady === 'true') return;

        const mainSlides = Array.from(gallery.querySelectorAll('[data-media-id]'));
        const thumbSlides = Array.from(gallery.querySelectorAll('.xo-product-info-media-style1__thumb-slide, .xo-product-info-media-style2__thumb-slide, .xo-product-info-media-style3__thumb-slide, .xo-product-info-media-style4__thumb-slide'));
        const prevButton = gallery.querySelector('xo-carousel-prev button');
        const nextButton = gallery.querySelector('xo-carousel-next button');

        if (!mainSlides.length) return;

        let currentIndex = 0;

        const activate = (index) => {
          if (!mainSlides.length) return;

          currentIndex = ((index % mainSlides.length) + mainSlides.length) % mainSlides.length;

          mainSlides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === currentIndex;
            slide.style.display = isActive ? '' : 'none';
            slide.setAttribute('xo-active', isActive ? 'true' : 'false');
          });

          thumbSlides.forEach((thumb, thumbIndex) => {
            const isActive = thumbIndex === currentIndex;
            thumb.setAttribute('xo-active', isActive ? 'true' : 'false');
            thumb.classList.toggle('is-active', isActive);
          });
        };

        thumbSlides.forEach((thumb, thumbIndex) => {
          thumb.style.cursor = 'pointer';
          thumb.addEventListener('click', () => activate(thumbIndex));
        });

        if (prevButton) {
          prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            activate(currentIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            activate(currentIndex + 1);
          });
        }

        activate(0);
        gallery.dataset.fallbackSyncReady = 'true';
      });
    };

    initDesktopMediaFallbackSync(document);
    document.addEventListener('shopify:section:load', (event) => initDesktopMediaFallbackSync(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-media-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const initMobileMediaFallbackSync = (root) => {
      const scope = root || document;
      scope.querySelectorAll('[data-product-media-mobile-root]').forEach((gallery) => {
        if (gallery.dataset.fallbackSyncReady === 'true') return;

        const mainSlides = Array.from(gallery.querySelectorAll('.xo-product-info-media-mobile__slide[data-media-id]'));
        const thumbSlides = Array.from(gallery.querySelectorAll('.xo-product-info-media-mobile__thumb-slide'));
        const bullets = Array.from(gallery.querySelectorAll('xo-carousel-pagination, .xo-product-info-media-mobile__pagination'));
        const prevButton = gallery.querySelector('.xo-product-info-media-mobile__arrow--left button');
        const nextButton = gallery.querySelector('.xo-product-info-media-mobile__arrow--right button');

        if (!mainSlides.length) return;

        let currentIndex = 0;

        const activate = (index) => {
          currentIndex = ((index % mainSlides.length) + mainSlides.length) % mainSlides.length;

          mainSlides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === currentIndex;
            slide.style.display = isActive ? '' : 'none';
            slide.setAttribute('xo-active', isActive ? 'true' : 'false');
          });

          thumbSlides.forEach((thumb, thumbIndex) => {
            const isActive = thumbIndex === currentIndex;
            thumb.setAttribute('xo-active', isActive ? 'true' : 'false');
            thumb.classList.toggle('is-active', isActive);
          });

          bullets.forEach((bulletWrap) => {
            bulletWrap.setAttribute('data-active-index', String(currentIndex));
          });
        };

        thumbSlides.forEach((thumb, thumbIndex) => {
          thumb.style.cursor = 'pointer';
          thumb.addEventListener('click', () => activate(thumbIndex));
        });

        if (prevButton) {
          prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            activate(currentIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            activate(currentIndex + 1);
          });
        }

        activate(0);
        gallery.dataset.fallbackSyncReady = 'true';
      });
    };

    initMobileMediaFallbackSync(document);
    document.addEventListener('shopify:section:load', (event) => initMobileMediaFallbackSync(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-side-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-search-panel]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const input = root.querySelector('.search-side-panel__input');
    const results = root.querySelector('[data-search-panel-results]');
    const pagesWrap = root.querySelector('[data-search-panel-pages-wrap]');
    const pagesList = root.querySelector('[data-search-panel-pages]');
    const productsList = root.querySelector('[data-search-panel-products]');
    const emptyState = root.querySelector('[data-search-panel-empty]');
    const openers = document.querySelectorAll('[data-open-search-panel]');
    const closers = root.querySelectorAll('[data-search-panel-close]');
    let controller;
    let timer;

    const escapeHtml = (value) =>
      String(value || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');

    const resetResults = () => {
      results.hidden = true;
      pagesWrap.hidden = true;
      pagesList.innerHTML = '';
      productsList.innerHTML = '';
      emptyState.hidden = true;
      emptyState.textContent = '';
    };

    const renderResults = (payload, term) => {
      const pages = payload?.resources?.results?.pages || [];
      const products = payload?.resources?.results?.products || [];

      results.hidden = false;

      if (pages.length) {
        pagesWrap.hidden = false;
        pagesList.innerHTML = pages
          .slice(0, 4)
          .map((page) => `<a class="search-side-panel__page-link" href="${page.url}">${escapeHtml(page.title)}</a>`)
          .join('');
      } else {
        pagesWrap.hidden = true;
        pagesList.innerHTML = '';
      }

      if (products.length) {
        productsList.innerHTML = products
          .slice(0, 6)
          .map((product) => {
            const image = product.featured_image?.url || '';
            const title = escapeHtml(product.title);
            return `
              <a class="search-side-panel__product" href="${product.url}">
                <div class="search-side-panel__product-media">
                  ${image ? `<img class="search-side-panel__product-image" src="${image}&width=360" alt="${title}" loading="lazy">` : ''}
                </div>
                <div class="search-side-panel__product-title">${title}</div>
              </a>
            `;
          })
          .join('');
        emptyState.hidden = true;
        emptyState.textContent = '';
      } else {
        productsList.innerHTML = '';
        emptyState.hidden = false;
        emptyState.textContent = `No results found for "${term}"`;
      }
    };

    const fetchResults = (term) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,page&resources[limit]=6&resources[options][unavailable_products]=last`;
      fetch(url, { signal: controller.signal })
        .then((response) => response.json())
        .then((payload) => renderResults(payload, term))
        .catch((error) => {
          if (error.name !== 'AbortError') {
            resetResults();
          }
        });
    };

    const open = () => {
      root.hidden = false;
      requestAnimationFrame(() => {
        root.classList.add('is-open');
        input?.focus();
      });
    };

    const close = () => {
      root.classList.remove('is-open');
      setTimeout(() => {
        if (!root.classList.contains('is-open')) {
          root.hidden = true;
        }
      }, 320);
    };

    openers.forEach((button) => {
      button.addEventListener('click', open);
    });

    closers.forEach((button) => {
      button.addEventListener('click', close);
    });

    input?.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 1) {
        resetResults();
        return;
      }
      timer = setTimeout(() => fetchResults(term), 180);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
